<template>
    <div class="result">
        <logo modifier="logo--result"></logo>

        <div class="result__text">
            <p>Helyes válaszok</p>
        </div>

        <div class="result__number">
            <p>{{ correctCount }}/3</p>
        </div>

        <div class="result__percent">
            <p>{{ roundedRatio }}%</p>
        </div>

        <div class="result__line" :style="styleObject">

        </div>

        <button-next v-bind:link="{ name: 'prizesScreen'}">
        </button-next>
    </div>
</template>

<script>
    import Vue from 'vue';
    import ButtonNext from '@/components/shared/ButtonNext';
    import Logo from '@/components/shared/LogoElement';

    export default {
        name: 'EndScreen',
        components: {
            'logo': Logo,
            'button-next': ButtonNext
        },

        data: function () {
            return {
                correctCount: 0,
                questions: []
            }
        },

        computed: {
            roundedRatio: function () {
                return Math.round((this.correctCount / 3) * 10000) / 100
            },
            styleObject: function () {
                return {
                    backgroundImage: "linear-gradient(to right, green " + this.roundedRatio + "%, red " + this.roundedRatio + "%)"
                }
            }
        },

        methods: {
            getQuestions: function () {
                if (localStorage.getItem(Vue.localStorageName)) {
                    this.questions = JSON.parse(localStorage.getItem(Vue.localStorageName));
                }
            },

            countCorrectAnswers: function () {

                var correctCount = 0;

                this.questions.forEach(element => {
                    if (element.correct == element.answered) {
                        correctCount++;
                    }

                    this.correctCount = correctCount;
                });
            }
        },
        mounted() {
            this.getQuestions();
            this.countCorrectAnswers();
        }
    }
</script>

<style lang="scss">
    .result {
        height: 100vh;
        width: 100%;
        background: url('~@/assets/images/background-green.png');
        text-align: center;

        &__text {
            p {
                font-size: 36px;
                line-height: 50px;
                margin: 45px 0px 0px 0px;
                text-transform: uppercase;
            }
        }

        &__number {
            p {
                font-weight: bold;
                font-size: 100px;
                line-height: 120px;
                margin: 0px;
            }
        }

        &__percent {
            p {
                font-size: 24px;
                line-height: 34px;
                margin: 0px 0px 55px 0px;
            }
        }

        &__line {
            height: 10px;
            width: 450px;
            margin: 0px auto 50px;

        }
    }

    .button-back {
        img {
            width: 56px;
            height: auto;
            cursor: pointer;
        }
    }
</style>


